export default {
  rewards: ({ rewards }) => rewards,
  rewardsPagination: ({ pagination }) => pagination,
  isLoadingRewards: ({ is_loading_rewards }) => is_loading_rewards,
  errorRewards: ({ is_error_rewards }) => is_error_rewards,
  isErrorRewards: ({ is_error_rewards }) => !!is_error_rewards,
  waitForRequestCount: ({ wait_for_request_count }) => wait_for_request_count,
  pendingCount: ({ pending_count }) => pending_count,
  isLoadingRewardDetail: ({ is_loading_reward_detail }) => is_loading_reward_detail,
  isErrorRewardDetail: ({ is_error_reward_detail }) => is_error_reward_detail,
  rewardDetail: ({ reward_detail }) => reward_detail,
  paginationRewardDetailList: ({ pagination_reward_detail }) => pagination_reward_detail,
};
